import React from 'react'
import Routes from 'routes.js'
import { createMuiTheme, responsiveFontSizes, ThemeProvider } from '@material-ui/core/styles'
import defaultTheme from 'theme/defaultTheme'
import FormDataProvider from 'components/contexts/FormDataProvider'

let theme = createMuiTheme(defaultTheme)
theme = responsiveFontSizes(theme)

function App() {
  return (
    <FormDataProvider>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </FormDataProvider>
  )
}

export default App
